export const HISTORY_DOCUMENTS = [
  "dateTime",
  "typeEvent",
  "comment",
  "user",
  "fileName",
];
